export default function({
  baseModuleActions,
  serviceAPI,
  makeCreateParams,
  makeUpdateParams,
  makeHttpParamsUrl,
  updateUrl,
}) {
  return {
    ...baseModuleActions,
    async createItem({ commit, getters, rootGetters }, item) {
      if (!item) return null;
      let getAllUrl = null;
      if (makeHttpParamsUrl) getAllUrl = makeHttpParamsUrl(getters.urlParamId);

      const newItem = makeCreateParams({ rootGetters, item });
      commit('CREATE_REQUEST', newItem);
      return serviceAPI
        .createItem(newItem, getAllUrl)
        .then((response) => {
          commit('CREATE_SUCCESS', response);
        })
        .catch((error) => commit('CREATE_ERROR', JSON.stringify(error)));
    },
    async updateItem({ commit, rootGetters }, item) {
      if (!item.id) return null;
      const { newItem } = makeUpdateParams({ rootGetters, item });
      commit('UPDATE_REQUEST', newItem);
      return serviceAPI
        .updateItem(newItem, updateUrl)
        .then((response) => {
          commit('UPDATE_SUCCESS', response);
        })
        .catch((error) => commit('UPDATE_ERROR', JSON.stringify(error)));
    },
    async deleteItem({ commit }, id) {
      commit('DELETE_REQUEST', id);
      return serviceAPI
        .deleteItem(id, updateUrl)
        .then((response) => {
          commit('DELETE_SUCCESS', response);
        })
        .catch((error) => commit('DELETE_ERROR', error));
    },
  };
}
